import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Divider from "@mui/material/Divider";

type ActionType = "detail" | "create" | "edit";

interface ActionDialogButtonProps {
  type: ActionType;
  open: boolean;
  handleClickOpen: () => void;
  handleClose: () => void;
  handleAction: () => void;
  changeEditMode?: boolean;
  handleChangeEditMode?: () => void;
  actionDisabled?: boolean;
  isSubmitting?: boolean;
}

const ActionDialogButton: React.FC<ActionDialogButtonProps> = ({
  type,
  open,
  handleClickOpen,
  handleClose,
  handleAction,
  changeEditMode,
  handleChangeEditMode,
  actionDisabled,
  isSubmitting,
}) => {
  const config = {
    detail: {
      buttonLabel: "削除",
      dialogText: "ミッションを削除しますか？",
      actionLabel: "削除",
      note: "※即時反映となりますのでご注意ください。", // 補足なし
    },
    create: {
      buttonLabel: "作成",
      dialogText: "ミッションを作成しますか？",
      actionLabel: "作成",
      note: "※作成後、即時配信となりますのでご注意ください。",
    },
    edit: {
      buttonLabel: "更新",
      dialogText: "ミッションを更新しますか？",
      actionLabel: "更新",
      note: "※即時反映となりますのでご注意ください。",
    },
  } as const;

  const { buttonLabel, dialogText, actionLabel, note } = config[type];

  return (
    <>
      <Box display="flex" justifyContent="center" sx={{ m: 3, pb: 2, gap: 8 }}>
        {changeEditMode ? (
          <>
            <Button
              variant="contained"
              color="primary"
              sx={{ width: 120, fontWeight: "bold" }}
              onClick={handleChangeEditMode}
            >
              編集する
            </Button>
            <Button
              variant="outlined"
              color="error"
              sx={{ width: 120, fontWeight: "bold" }}
              onClick={handleClickOpen}
              disabled={actionDisabled}
            >
              {buttonLabel}
            </Button>
          </>
        ) : (
          <Button
            variant="contained"
            color="primary"
            sx={{ width: 120, fontWeight: "bold" }}
            onClick={handleClickOpen}
            disabled={actionDisabled}
          >
            {buttonLabel}
          </Button>
        )}
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{dialogText}</DialogTitle>

        <Divider />

        <DialogContent>
          <DialogContentText id="alert-dialog-description"></DialogContentText>
          {note && (
            <DialogContentText sx={{ color: "text.secondary" }}>
              {note}
            </DialogContentText>
          )}
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", gap: 1 }}>
          <Button
            onClick={handleAction}
            variant="contained"
            color={type === "detail" ? "error" : "primary"}
            sx={{ minWidth: 120 }}
            disabled={isSubmitting}
          >
            {actionLabel}
          </Button>
          <Button
            onClick={handleClose}
            variant="outlined"
            autoFocus
            sx={{ minWidth: 120 }}
            disabled={isSubmitting}
          >
            キャンセル
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ActionDialogButton;
